export const employeeColumns = [
    {
        name: "User Id",
        selector: (row) => row["userId"],
        sortable: true,
        // center: true,
        width: "100px"
    },
    {
        name: "Full Name",
        selector: (row) => row["fullName"],
        sortable: true,
        // center: true,
        width: "180px"
    },
    {
        name: "Email",
        selector: (row) => row["email"],
        sortable: true,
        // center: true,
        width: "250px"
    },
    {
        name: "Mobile",
        selector: (row) => row["mobile"],
        sortable: true,
        // center: true,
        width: "150px"
    },
    {
        name: "Activated",
        selector: (row) => row["activated"],
        sortable: true,
        // center: true,
        width: "100px"
    },
    {
        name: "Service Cities",
        selector: (row) => row["serviceCities"],
        sortable: true,
        // center: true,
        
    },
    {
        name: "Authorities",
        selector: (row) => row["authorities"],
        sortable: true,
        // center: true,
        
    },
    {
        name: "",
        selector: (row) => row["action"],
        sortable: true,
        center: true,
        width: "50px",
        // style: {
        //   backgroundColor: "white",
        //   position: "sticky",
        //   right: 0,
        //   zIndex: 0,
        //   justifyContent: "center !important"
        // },
      },
];